import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Claimants from "./pages/Claimants";
import ClaimantDetail from "./pages/ClaimantDetail";
import Products from "./pages/Products";
import BankTransferExports from "./pages/BankTransferExports";
import Settings from "./pages/Settings";
import Login from "./pages/Login";
import LinksPage from "./pages/LinksPage";
import { useAuthStore } from "./store/authStore";
import { useEffect } from "react";

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { token, role } = useAuthStore();
  const adminRoles = ["admin", "super_admin", "payout_manager"];
  if (!token || !adminRoles.includes(role || "")) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

function App() {
  // Apply dark mode class based on system preference
  useEffect(() => {
    const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }

    // Listen for system theme changes
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e: MediaQueryListEvent) => {
      if (e.matches) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return (
    <>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="claimants" element={<Claimants />} />
          <Route path="claimants/:id" element={<ClaimantDetail />} />
          <Route path="products" element={<Products />} />
          <Route path="settings" element={<Settings />} />
          <Route path="exports" element={<BankTransferExports />} />
          <Route path="links" element={<LinksPage />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
